import strip from './settlement-bridge-strip-art.json';
import {
  settlementBridgeDeckManifest,
  settlementIslandBridgeContacts,
} from './settlement-island-bridges';
import type { SettlementBridgeMaterialPlan } from './settlement-bridge-material';

/** Authored basin connections need no second deck, posts or material download. */
export function settlementBridgeDeckDelivery(
  districts: readonly { code: string; unlocked: boolean }[],
) {
  const bridges = districts.filter(
    ({ code, unlocked }) => unlocked && Object.hasOwn(settlementIslandBridgeContacts, code),
  );
  return bridges.length ? settlementBridgeDeckManifest : undefined;
}

export const settlementGardenBridgeStripId = strip.id;

/** Image and canvas resamplers differ. Restore the same canvas source before projection. */
export function rehydrateSettlementBridgeStrip(image: HTMLImageElement): HTMLCanvasElement | null {
  const canvas = document.createElement('canvas');
  canvas.width = image.naturalWidth;
  canvas.height = image.naturalHeight;
  const context = canvas.getContext('2d');
  if (!context) return null;
  context.drawImage(image, 0, 0);
  return canvas;
}

/** Retained original sampler, also used when immutable strip delivery fails. */
export function assembleSettlementBridgeStrip(
  image: HTMLImageElement,
  material: SettlementBridgeMaterialPlan,
): HTMLCanvasElement | null {
  const canvas = document.createElement('canvas');
  const sourceWidth = material.timber.reduce(
    (sum, { source }) => sum + source[1].x - source[0].x,
    0,
  );
  const sourceHeight =
    settlementBridgeDeckManifest.sourceQuad[3].y - settlementBridgeDeckManifest.sourceQuad[0].y;
  canvas.width = Math.min(1024, Math.ceil(sourceWidth));
  canvas.height = Math.max(1, Math.ceil((sourceHeight * canvas.width) / sourceWidth));
  const context = canvas.getContext('2d');
  if (!context) return null;
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = 'high';
  let cursor = 0;
  for (const { source } of material.timber) {
    const span = source[1].x - source[0].x;
    const from = Math.round((cursor * canvas.width) / sourceWidth);
    cursor += span;
    const to = Math.round((cursor * canvas.width) / sourceWidth);
    context.drawImage(
      image,
      source[0].x,
      source[0].y,
      span,
      sourceHeight,
      from,
      0,
      to - from,
      canvas.height,
    );
  }
  return canvas;
}
